import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import {post} from 'bukku/shared/ApiService';
import {t} from "@lingui/macro";

// Create transactions
export function* createTransactionsRequest() {
    yield takeEvery(actions.IMPORT_CREATE_TRANSACTIONS_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/import/transactions/multiple', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.IMPORT_CREATE_TRANSACTIONS_SUCCESS,
                data,
            });
        }
        catch (error) {
            yield put({
                type: actions.IMPORT_CREATE_TRANSACTIONS_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createTransactionsSuccess() {
    yield takeEvery(actions.IMPORT_CREATE_TRANSACTIONS_SUCCESS, function* ({ data }) {
        yield message.success(t`${data.count} transactions are imported into Bukku.`);
    });
}
export function* createTransactionsError() {
    yield takeEvery(actions.IMPORT_CREATE_TRANSACTIONS_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(createTransactionsRequest),
        fork(createTransactionsSuccess),
        fork(createTransactionsError),
    ]);
}
